module.exports = __webpack_public_path__ + "static/media/icon_arrow_left_blue.0a5515ea.svg";